import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    Column,
    DataGrid,
    LoadPanel as DataGridLoadPanel,
    Selection,
    Sorting,
    Paging,
    FilterRow
} from "devextreme-react/data-grid";

function ShowDistinctItems(props) {
    const { transactionHeaderId, onClose, accessToken, customerIdentity } = props;
    const [distinctItems, setDistinctItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDistinctItems();
    }, [transactionHeaderId, customerIdentity]);

    const fetchDistinctItems = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/TransactionDetailOperations/GetDistinctItems`,
                {
                    params: {
                        transactionHeaderId: transactionHeaderId,
                        customerId: customerIdentity
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            setDistinctItems(response.data || []);
        } catch (error) {
            console.error("Error fetching distinct items:", error);
            setDistinctItems([]);
        } finally {
            setLoading(false);
        }
    };

    const onRowClick = async (e) => {
        if (!e.data) return;

        const selectedItem = e.data;
        
        try {
            // Call the callback with the itemCode
            if (props.onItemSelected) {
                await props.onItemSelected(selectedItem.itemCode);
            }

            // Close the popup
            if (onClose) {
                onClose();
            }
        } catch (error) {
            console.error("Error selecting item:", error);
        }
    };

    return (
        <div style={{ padding: "10px", height: "100%", display: "flex", flexDirection: "column" }}>
            <DataGrid
                dataSource={distinctItems}
                showBorders={true}
                height="100%"
                onRowClick={onRowClick}
                keyExpr="itemCode"
            >
                <DataGridLoadPanel enabled={true} />
                <Selection mode="single" />
                <Sorting mode="single" />
                <Paging enabled={false} />
                <FilterRow visible={true} />
                <Column 
                    dataField="itemCode" 
                    caption="Item Code" 
                    allowSorting={true}
                    width={150}
                />
                <Column 
                    dataField="itemDesc1" 
                    caption="Description 1" 
                    allowSorting={true}
                />
                <Column 
                    dataField="itemDesc2" 
                    caption="Description 2" 
                    allowSorting={true}
                />
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ShowDistinctItems);

